'use strict';

// Product workspace. The reusable EntityMetadataWorkspace provider renders the record's MetadataJSON blob as the
// guided per-customer metadata form (read-only + inline Edit/Save) underneath the Overview field groups.
const libEntityMetadataWorkspaceProvider = require('../providers/EntityMetadataWorkspace-Provider.js');

module.exports = {
	Identifier: 'ProductWorkspace', Ordinal: 245,
	ProviderClass: libEntityMetadataWorkspaceProvider,
	// Meadow exposes the DB column MetadataJSON as the field `Metadata`, returned as an already-parsed object.
	MetadataBlob: { column: 'Metadata', label: 'Product Metadata', encoding: 'object' },
	Entity: { Name: 'Product', IDField: 'IDProduct', Collection: 'Products', GUIDField: 'GUIDProduct' },
	Header: { Eyebrow: 'Product', Title: (r) => r.Name || `Product ${r.IDProduct}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Product/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'childlist', ref: 'Sample', parentField: 'IDProduct',
			columns: [ { Key: 'LabControlNumber', Label: 'PSID' }, { Key: 'Name', Label: 'Description' } ], empty: 'No samples of this product.', cap: 200 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'ManufacturerCode', Label: 'Mfr Code', Mono: true }, { Key: 'CatalogCode', Label: 'Catalog Code', Mono: true } ] } ],
};
